export const globalSettingsIssuesFieldConfigureRoute = {
	name: 'global-settings-issues-field-configure',
	path: '/secure/admin/ConfigureFieldScreen.jspa',
};
